import { render, staticRenderFns } from "./CurrencyComponent.vue?vue&type=template&id=db024f22&scoped=true"
import script from "./CurrencyComponent.vue?vue&type=script&lang=ts"
export * from "./CurrencyComponent.vue?vue&type=script&lang=ts"
import style0 from "./CurrencyComponent.vue?vue&type=style&index=0&id=db024f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db024f22",
  null
  
)

export default component.exports